module.exports = __webpack_public_path__ + "img/Image20230811133042.57bddeff.png";